// Géocodage gratuit via Nominatim (OpenStreetMap) — pas de clé API requise.
// Conformité Nominatim : 1 requête / seconde max, on ajoute un User-Agent via Referer.
let lastCall = 0;

export async function geocodeAddress(query) {
  if (!query || query.length < 3) return null;
  // Throttle 1 req/sec
  const now = Date.now();
  const wait = Math.max(0, 1100 - (now - lastCall));
  if (wait > 0) await new Promise((r) => setTimeout(r, wait));
  lastCall = Date.now();

  // Biais sur la région d'Istres (PACA, France)
  const params = new URLSearchParams({
    q: query.includes("Istres") || query.includes("13800") ? query : `${query}, Istres, France`,
    format: "json",
    limit: "1",
    "accept-language": "fr",
    countrycodes: "fr",
  });
  try {
    const res = await fetch(`https://nominatim.openstreetmap.org/search?${params}`, {
      headers: { "Accept": "application/json" },
    });
    if (!res.ok) return null;
    const data = await res.json();
    if (!data || !data.length) return null;
    const top = data[0];
    return {
      lat: parseFloat(top.lat),
      lng: parseFloat(top.lon),
      display_name: top.display_name,
    };
  } catch {
    return null;
  }
}
